<ng-template #modalLG let-modal>
    <div class="modal-header" style="background-color: transparent;" aria-label="Modal Header">
        <button type="button" class="close" (click)="cancelModal()" aria-label="Close Modal">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body p-0" tabindex="0" ngbAutofocus>
        <div style="padding: 30px 64px 64px 64px">
            <div class="text-center " role="alert" aria-live="polite">
                <p class="fw-bold titre">Ajoutez des taxes</p>
                <p class="sous-titre">Veuillez renseigner les informations requises pour enregistrer une taxe.</p>
            </div>
            <form #taxeForm="ngForm" (ngSubmit)="onSubmit(taxeForm)" style="padding-left: 14px">
                <div class="row" >
                    <!-- Nom -->
                    <div class="p-0" style="margin-right: 12px">
                        <label for="taxeNom" class="form-label">Nom <span class="text-danger" aria-hidden="true">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                id="taxeNom"
                                name="nom"
                                [(ngModel)]="TaxeData.nom"
                                placeholder="Entrez le nom"
                                aria-required="true"
                                required
                                style="width: 374px;"
                                maxlength="200"
                                #nomInput="ngModel"
                                [ngClass]="{'is-invalid': nomInput.invalid && (nomInput.dirty || nomInput.touched || taxeForm.submitted)}"
                        >
                        <div *ngIf="nomInput.invalid && (nomInput.dirty || nomInput.touched || taxeForm.submitted)" class="invalid-feedback">
                            <span *ngIf="nomInput.errors?.required">Le nom est requis.</span>
                            <span *ngIf="nomInput.errors?.maxlength">Le nom ne doit pas dépasser 200 caractères.</span>
                        </div>
                    </div>
                    <!-- Label -->
                    <div class="p-0" style="margin-left: 12px">
                        <label for="taxeLabel" class="form-label">Libellé <span class="text-danger" aria-hidden="true">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                id="taxeLabel"
                                name="label"
                                [(ngModel)]="TaxeData.label"
                                placeholder="Entrez le libellé"
                                aria-required="true"
                                required
                                style="width: 374px;"
                                maxlength="200"
                                #labelInput="ngModel"
                                [ngClass]="{'is-invalid': labelInput.invalid && (labelInput.dirty || labelInput.touched || taxeForm.submitted)}"
                        >
                        <div *ngIf="labelInput.invalid && (labelInput.dirty || labelInput.touched || taxeForm.submitted)" class="invalid-feedback">
                            <span *ngIf="labelInput.errors?.required">Le libellé est requis.</span>
                            <span *ngIf="labelInput.errors?.maxlength">Le libellé ne doit pas dépasser 200 caractères.</span>
                        </div>
                    </div>
                    <!-- Valeur et type -->
                    <div class="col-12 form-group" style="padding: 0 0.5rem; margin-bottom: 0.5rem;">
                        <div class="d-flex align-items-center flex-wrap gap-1" role="group" aria-label="Options de valeur et type" style="margin-top: 24px">
                            <!-- + / - -->
                            <div class="form-check form-check-inline">
                                <input
                                        type="radio"
                                        class="form-check-input"
                                        name="type"
                                        value="+"
                                        id="plus"
                                        [(ngModel)]="TaxeData.type"
                                        required
                                        #typeInput="ngModel"
                                        [ngClass]="{'is-invalid': typeInput.invalid && (typeInput.dirty || typeInput.touched || taxeForm.submitted)}"
                                >
                                <label for="plus" class="form-check-label text-dark">+</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input
                                        type="radio"
                                        class="form-check-input"
                                        name="type"
                                        value="-"
                                        id="moins"
                                        [(ngModel)]="TaxeData.type"
                                        required
                                        #typeInput="ngModel"
                                        style="margin-left: 0.5rem;"
                                        [ngClass]="{'is-invalid': typeInput.invalid && (typeInput.dirty || typeInput.touched || taxeForm.submitted)}"
                                >
                                <label for="moins" class="form-check-label text-dark">-</label>
                            </div>
                            <div *ngIf="typeInput.invalid && (typeInput.dirty || typeInput.touched || taxeForm.submitted)" class="invalid-feedback">
                                <span *ngIf="typeInput.errors?.required">Le type est requis.</span>
                            </div>
                            <!-- Input + / - boutons -->
                            <div class="input-group align-items-center mb-0" style="width: 166px; margin-left: 4rem;" aria-label="Ajustement de la valeur">
                                <button
                                        class="btn p-0 d-flex justify-content-center align-items-center del-button"
                                        type="button"
                                        style="width: 38px; height: 38px; background-color: rgba(255, 76, 81, 0.16);"
                                        (click)="decrementValue()"
                                        aria-label="Décrémenter"
                                        [disabled]="TaxeData.valeur <= 1"
                                >
                                    -
                                </button>
                                <input
                                        type="number"
                                        class="form-control text-center"
                                        name="valeur"
                                        [(ngModel)]="TaxeData.valeur"
                                        id="taxeValue"
                                        min="1"
                                        max="999999999"
                                        step="0.1"
                                        pattern="[0-9]+(\.[0-9]{1,2})?"
                                        maxlength="10"
                                        style="width: 90px; height: 38px;"
                                        aria-label="Valeur de la taxe"
                                        required
                                        #valeurInput="ngModel"
                                        [ngClass]="{'is-invalid': valeurInput.invalid && (valeurInput.dirty || valeurInput.touched || taxeForm.submitted)}"
                                        (ngModelChange)="onValueChange()"
                                >
                                <button
                                        class="btn p-0 d-flex justify-content-center align-items-center add-button"
                                        type="button"
                                        style="width: 38px; height: 38px; background-color: rgba(255, 76, 81, 0.16);"
                                        (click)="incrementValue()"
                                        aria-label="Incrémenter"
                                >
                                    +
                                </button>
                                <div *ngIf="valeurInput.invalid && (valeurInput.dirty || valeurInput.touched || taxeForm.submitted)" class="invalid-feedback">
                                    <span *ngIf="valeurInput.errors?.required">La valeur est requise.</span>
                                    <span *ngIf="valeurInput.errors?.min">La valeur doit être supérieure ou égale à 1.</span>
                                    <span *ngIf="valeurInput.errors?.pattern">Veuillez entrer un nombre valide (ex. 1.5).</span>
                                    <span *ngIf="isValueTooLong()">La valeur ne doit pas dépasser 10 caractères.</span>
                                </div>
                            </div>
                            <!-- Pourcentage / Fixe -->
                            <div class="form-check form-check-inline ms-2" style="margin-left: 5rem;" role="group" aria-label="Type de valeur">
                                <input
                                        type="radio"
                                        class="form-check-input"
                                        name="valeur_pourcentage"
                                        [value]="true"
                                        id="Pourcentage"
                                        [(ngModel)]="TaxeData.valeur_pourcentage"
                                        (ngModelChange)="TaxeData.valeur_fixe = !TaxeData.valeur_pourcentage"
                                        required
                                        #valeurPourcentageInput="ngModel"
                                        [ngClass]="{'is-invalid': valeurPourcentageInput.invalid && (valeurPourcentageInput.dirty || valeurPourcentageInput.touched || taxeForm.submitted)}"
                                >
                                <label for="Pourcentage" class="form-check-label text-dark">Pourcentage</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input
                                        type="radio"
                                        class="form-check-input"
                                        name="valeur_pourcentage"
                                        [value]="false"
                                        id="Fixe"
                                        [(ngModel)]="TaxeData.valeur_pourcentage"
                                        (ngModelChange)="TaxeData.valeur_fixe = !TaxeData.valeur_pourcentage"
                                        required
                                        #valeurPourcentageInput="ngModel"
                                        style="margin-left: 0.5rem;"
                                        [ngClass]="{'is-invalid': valeurPourcentageInput.invalid && (valeurPourcentageInput.dirty || valeurPourcentageInput.touched || taxeForm.submitted)}"
                                >
                                <label for="Fixe" class="form-check-label text-dark">Fixe</label>
                            </div>
                            <div *ngIf="valeurPourcentageInput.invalid && (valeurPourcentageInput.dirty || valeurPourcentageInput.touched || taxeForm.submitted)" class="invalid-feedback">
                                <span *ngIf="valeurPourcentageInput.errors?.required">Le type de valeur est requis.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 form-group p-0" style="margin: 24px 0 0 0" role="group" aria-label="Options d'application">
                        <label class="text-dark" style="margin-bottom: 8px">Application <span class="text-danger" aria-hidden="true" >*</span></label>
                        <br>
                        <div class="form-check form-check-inline" >
                            <input
                                    type="radio"
                                    class="form-check-input"
                                    name="application"
                                    value="avant_tva"
                                    id="Avant_tva"
                                    (ngModelChange)="TaxeData.applique_avant_tva = $event === 'avant_tva'; TaxeData.applique_apres_tva = $event === 'apres_tva'"
                                    [ngModel]="TaxeData.applique_avant_tva ? 'avant_tva' : (TaxeData.applique_apres_tva ? 'apres_tva' : null)"
                                    required
                                    #applicationInput="ngModel"
                                    [ngClass]="{'is-invalid': applicationInput.invalid && (applicationInput.dirty || applicationInput.touched || taxeForm.submitted)}"
                            >
                            <label for="Avant_tva" class="form-check-label text-dark">Avant la TVA</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input
                                    type="radio"
                                    class="form-check-input"
                                    name="application"
                                    value="apres_tva"
                                    id="Apres_tva"
                                    (ngModelChange)="TaxeData.applique_avant_tva = $event === 'avant_tva'; TaxeData.applique_apres_tva = $event === 'apres_tva'"
                                    [ngModel]="TaxeData.applique_apres_tva ? 'apres_tva' : (TaxeData.applique_avant_tva ? 'avant_tva' : null)"
                                    required
                                    #applicationInput="ngModel"
                                    style="margin-left: 0.5rem;"
                                    [ngClass]="{'is-invalid': applicationInput.invalid && (applicationInput.dirty || applicationInput.touched || taxeForm.submitted)}"
                            >
                            <label for="Apres_tva" class="form-check-label text-dark">Après la TVA</label>
                        </div>
                        <div *ngIf="applicationInput.invalid && (applicationInput.dirty || applicationInput.touched || taxeForm.submitted)" class="invalid-feedback">
                            <span *ngIf="applicationInput.errors?.required">L'application est requise.</span>
                        </div>
                    </div>
                    <div class="col-12 form-group p-0" style="margin: 24px 0 0 0"  role="group" aria-label="Options d'utilisation">
                        <label class="text-dark" style="margin-bottom: 8px" >Utilisation <span class="text-danger" aria-hidden="true" >*</span></label>
                        <br>
                        <div class="form-check form-check-inline" >
                            <input
                                    type="radio"
                                    class="form-check-input"
                                    name="utilisation"
                                    value="tout"
                                    id="Tout"
                                    [ngModel]="TaxeData.applique_sur_product ? 'produits' : 'tout'"
                                    (ngModelChange)="TaxeData.applique_sur_product = $event === 'produits'"
                                    required
                                    #utilisationInput="ngModel"
                                    [ngClass]="{'is-invalid': utilisationInput.invalid && (utilisationInput.dirty || utilisationInput.touched || taxeForm.submitted)}"
                            >
                            <label for="Tout" class="form-check-label text-dark">Tous</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input
                                    type="radio"
                                    class="form-check-input"
                                    name="utilisation"
                                    value="ventes"
                                    id="ventes"
                                    [ngModel]="TaxeData.applique_sur_product ? 'produits' : 'ventes'"
                                    (ngModelChange)="TaxeData.applique_sur_product = $event === 'produits'"
                                    required
                                    #utilisationInput="ngModel"
                                    style="margin-left: 0.5rem;"
                                    [ngClass]="{'is-invalid': utilisationInput.invalid && (utilisationInput.dirty || utilisationInput.touched || taxeForm.submitted)}"
                            >
                            <label for="ventes" class="form-check-label text-dark">Ventes</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input
                                    type="radio"
                                    class="form-check-input"
                                    name="utilisation"
                                    value="achat"
                                    id="achat"
                                    [ngModel]="TaxeData.applique_sur_product ? 'produits' : 'achat'"
                                    (ngModelChange)="TaxeData.applique_sur_product = $event === 'produits'"
                                    required
                                    #utilisationInput="ngModel"
                                    style="margin-left: 0.5rem;"
                                    [ngClass]="{'is-invalid': utilisationInput.invalid && (utilisationInput.dirty || utilisationInput.touched || taxeForm.submitted)}"
                            >
                            <label for="achat" class="form-check-label text-dark">Achat</label>
                        </div>
                        <div *ngIf="utilisationInput.invalid && (utilisationInput.dirty || utilisationInput.touched || taxeForm.submitted)" class="invalid-feedback">
                            <span *ngIf="utilisationInput.errors?.required">L'utilisation est requise.</span>
                        </div>
                    </div>
                    <!-- Checkbox -->
                    <div class="col-12" style="padding: 24px 0 0 0">
                        <div class="form-check">
                            <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="taxeAppliqueSurProduits"
                                    name="taxe_applique_sur_produits"
                                    [(ngModel)]="TaxeData.taxe_applique_sur_produits"
                            >
                            <label class="form-check-label" for="taxeAppliqueSurProduits">Appliquer la taxe aux produits</label>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-center border-0 p-0" style="padding-top: 31px; gap: 24px" role="region" aria-label="Actions de validation">
                    <button
                            type="submit"
                            class="btn btn-primary"
                            [disabled]="taxeForm.invalid || isLoading"
                            aria-label="Ajouter la taxe"
                    >
                        <span>Ajouter</span>
                        <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status">
              <span class="sr-only">Chargement...</span>
            </span>
                    </button>
                    <button
                            type="button"
                            class="btn btn-default"
                            style="background-color: #80839029;"
                            (click)="cancelModal()"
                            [disabled]="isLoading"
                            aria-label="Annuler l'ajout"
                    >
                        Annuler
                    </button>
                </div>
            </form>
        </div>
    </div>
</ng-template>